/**
 * The single place the backend origin is resolved.
 *
 * Deployment topology, decided rather than implied:
 *
 *  - Cross-origin (production today): REACT_APP_BACKEND_URL is set to the
 *    backend origin at build time, e.g. "https://api.example.com".
 *  - Same-origin (CI browser job, a reverse-proxied deploy): the variable is
 *    set to the EMPTY STRING, deliberately. Requests go to "/api/..." on the
 *    serving origin.
 *  - Absent: a misconfigured build. CRA inlines `undefined`, and every
 *    template that interpolated it produced the literal path
 *    "/undefined/api/..." — a bundle that looks deployed and cannot reach
 *    anything. `yarn build` now refuses to produce that bundle
 *    (scripts/check-backend-url.js); this module is the runtime belt for a
 *    bundle built some other way: it falls back to same-origin and says so
 *    loudly, because a same-origin guess that hits a real reverse proxy
 *    still works, while "/undefined/api" never can.
 */
const raw = process.env.REACT_APP_BACKEND_URL;

if (raw === undefined || raw === null) {
  // eslint-disable-next-line no-console
  console.error(
    "REACT_APP_BACKEND_URL was absent at build time. Falling back to " +
      "same-origin /api. Set it to the backend origin, or to '' to choose " +
      "same-origin deliberately."
  );
}

/** The backend origin, no trailing slash. Empty string means same-origin. */
export const BACKEND_URL = (raw ?? "").trim().replace(/\/+$/, "");

/** The REST base every caller should use. */
export const API_BASE_URL = `${BACKEND_URL}/api`;
